import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';

import { Title } from 'src/onboarding/components/typography/Title/Title';

import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const socialEating = useStore((state) => state.socialEating);
  const setSocialEating = useStore((state) => state.setSocialEating);
  const { onNext, onPrev, currentIndex } = useNav();


  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.socialEating.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={socialEating}
          onChange={(value) => {
            setSocialEating(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'social-eating',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={"They eat healthy regularly"}>
            <span>🥗</span> {t('onboarding.socialEating.options.regularly')}
          </Option>
          <Option value={"They eat healthy sometimes"}>
            <span>🍏</span> {t('onboarding.socialEating.options.sometimes')}
          </Option>
          <Option value={"They mostly eat unhealthy"}>
            <span>🍔</span> {t('onboarding.socialEating.options.unhealthy')}
          </Option>
          <Option value={"I’m not sure"}>
            <span>🤔</span> {t('onboarding.socialEating.options.notSure')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
